<template>
  <div class="thumbnail" v-if="attachment.thumbImageUrl">
    <a :href="attachment.url" data-type="image" target="_blank">
      <img
        :alt="altText"
        :src="attachment.thumbImageUrl"
        class="thumbnail__image"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'thumbnail',
  props: {
    attachment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    altText() {
      return this.attachment.name ||
        this.attachment.fileName ||
        this.attachment.url;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Thumbnail.vue?00caf06e